import { FormInput } from "@Rolec-Services/rolec-ui";
import { useTranslation } from "react-i18next";
import { StepProps } from "../organisms/step";

type ContactFieldsProps = {
  name:
    | "team.owner"
    | "team.finance"
    | "team.employee"
    | "installation.installer";
  control: StepProps["control"];
  nameLabel: string;
  telephoneLabel: string;
  emailLabel: string;
};

export function ContactFields({
  name,
  control,
  nameLabel,
  telephoneLabel,
  emailLabel,
}: ContactFieldsProps) {
  const { t } = useTranslation();
  return (
    <>
      <FormInput
        errorMessage={t("Required")}
        control={control}
        name={`${name}.name`}
        label={t(nameLabel)}
      />
      <FormInput
        errorMessage={t("Required")}
        control={control}
        name={`${name}.telephone`}
        label={t(telephoneLabel)}
      />
      <FormInput
        errorMessage={t("Required")}
        control={control}
        name={`${name}.email`}
        label={t(emailLabel)}
      />
    </>
  );
}
